import { SearchOutlined } from '@ant-design/icons';
import { Button, Space, Card } from 'antd';
import React from 'react';


function Buttons() {
  return (
    <Card title="Button">
      <Space>
        <Button type="primary">Save</Button>
        <Button type="primary" disabled>Save</Button>
        <Button>Cancel</Button>
        <Button disabled>Cancel</Button>
        <Button type="text">Select</Button>
        <Button type="text" disabled>Select</Button>
        <Button type="link">Contact</Button>
        <Button type="link" disabled>Contact</Button>
        <Button danger>Delete</Button>
        <Button danger disabled>Delete</Button>
        <Button icon={<SearchOutlined/>} />
        <Button icon={<SearchOutlined/>} disabled />
      </Space>
    </Card>
  )
}


export default Buttons;
